import type {
  GetListVisibleSortsProps,
  ListLazy,
  ListLazyOptions,
} from "./list.type";
import type { TableViewFilters, TableViewSort } from "@/entities/table-view";
import type { UseListParams } from "@/hooks/queries";

import omitBy from "lodash/omitBy";

import { LIST_LAZY_DEFAULT_SCROLL_THRESHOLD } from "./list.constant";

export const getListLazyHeight = (lazy: ListLazyOptions): number => {
  const { scrollY } = lazy;

  if ("maxHeight" in scrollY) return scrollY.maxHeight;

  return window.innerHeight - scrollY.vhDiff;
};

export const getListLazyHeightInCss = (lazy: ListLazyOptions): string => {
  const { scrollY } = lazy;

  if ("maxHeight" in scrollY) return `${scrollY.maxHeight}px`;

  return `calc(100vh - ${scrollY.vhDiff}px)`;
};

export const getListLazyThreshold = (lazy?: ListLazy): number => {
  const threshold = !lazy ? undefined : lazy.threshold;
  return threshold ?? LIST_LAZY_DEFAULT_SCROLL_THRESHOLD;
};

export const isEmptyListFetchParam = (param: unknown) =>
  param === "" || param === undefined || param === null;

export const getListCleanFetchParams = (params: object) => {
  return omitBy(params, isEmptyListFetchParam) as UseListParams;
};

/**
 * Returns filters formatted for fetch calls to Api
 *
 * @param filters TableViewFilters
 * @returns Record<string, string>
 */
export const convertFiltersToFetchFilters = (filters: TableViewFilters) => {
  const fetchFilters: Record<string, string> = {};

  Object.entries(filters).forEach(([filterKey, filterValue]) => {
    if (filterValue?.length) {
      const fetchFilterKey = /^filter\[/.test(filterKey)
        ? filterKey
        : `filter[${filterKey}]`;
      fetchFilters[fetchFilterKey] = filterValue.join(",");
    }
  });

  return fetchFilters;
};

export const getListVisibleSorts = ({
  sort,
  columns,
}: GetListVisibleSortsProps): TableViewSort => {
  if (!sort || !columns) return [];

  const visibleKeys = columns.map((column) => column.sortKey);

  return sort.filter((sortKey) =>
    visibleKeys.includes(sortKey.replace("-", ""))
  );
};
